import React, { useEffect, useReducer, useState } from "react";
import parse from "html-react-parser";
import moment from "moment";
import locale from "locale";
import { ControlLabel, FormGroup, Table, Button } from "react-bootstrap";
import Tooltip from "../../../UI/Tooltip";
import PaginationBar from "../../../PaginationBar";
import { RECIPIENTS_LETTER_STATUSES } from "../constants";
import ReminderRecipientsFilter from "./ReminderRecipientsFilter";
import Loading from "../../../Loading";

const RECIPIENTS_ON_PAGE = 20;

const ReminderRecipientsTable = ({ recipients, onSendMail }) => {
    const [isLoading, setLoading] = useState(false);
    const [visibleRecipients, setVisibleRecipients] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [filters, setFilters] = useReducer((prev, next) => {
            return {...prev, ...next};
        },
        {
            email: '',
            sentAt: '',
            status: '',
            opened: '',
        },
    );

    useEffect(() => {
        setVisibleRecipients(recipients);
        handleChangeRecipientsVisibility();
        setPageCount(Math.ceil(recipients.length / RECIPIENTS_ON_PAGE));
    }, [recipients]);

    useEffect(() => {
        handleChangeRecipientsVisibility();
    }, [activePage, filters]);

    function handleChangeRecipientsVisibility() {
        setLoading(true);
        let filteredRecipients = [...recipients];

        if (Object.values(filters).some(Boolean)) {
            filteredRecipients = handleFilterRecipients(filteredRecipients);
        }

        setPageCount(Math.ceil(filteredRecipients.length / RECIPIENTS_ON_PAGE));

        const recipientsPerPage = filteredRecipients.slice((activePage - 1) * RECIPIENTS_ON_PAGE, activePage * RECIPIENTS_ON_PAGE);
        setVisibleRecipients(recipientsPerPage);
        setLoading(false);
    }

    function handleFilterRecipients(data) {
        let filteredRecipients = data;

        if (filters.email) {
            filteredRecipients = filteredRecipients?.filter(({email}) => email.includes(filters.email));
        }

        if (filters.sentAt) {
            filteredRecipients = filteredRecipients?.filter(({sentAt}) => {
                return sentAt && moment.unix(sentAt).format('YYYY-MM-DD HH:mm:ss').includes(filters.sentAt);
            });
        }

        if (filters.status) {
            filteredRecipients = filteredRecipients?.filter(({status}) => {
                return RECIPIENTS_LETTER_STATUSES[status].toLowerCase().includes(filters.status);
            });
        }

        if (filters.opened) {
            filteredRecipients = filteredRecipients?.filter(({opened}) => {
                const openedValue = locale(`reminders.${opened ? 'yes' : 'no'}`);
                return openedValue.toLowerCase().includes(filters.opened);
            });
        }

        return filteredRecipients;
    }

    const handleChangeFilter = (key, value) => {
        setFilters({[key]: value.toLowerCase()});
    };

    return (
        <>
            {isLoading
                ? <Loading />
                : <>
                    <FormGroup style={{ marginTop: '20px' }}>
                            <ControlLabel>Список получателей</ControlLabel>
                        </FormGroup>
                        <Table>
                            <thead>
                                <tr>
                                    <th>E-mail</th>
                                    <th>Дата отправки</th>
                                    <th>
                                        Статус SMTP сервера
                                        <Tooltip width="440px">
                                            {parse(locale('reminders.recipientsStatuses'))}
                                        </Tooltip>
                                    </th>
                                    <th>Открыто</th>
                                    <th width={40}></th>
                                </tr>
                                <tr>
                                    <ReminderRecipientsFilter
                                        filters={filters}
                                        onChange={handleChangeFilter}
                                    />
                                </tr>
                            </thead>
                            <tbody>
                                {visibleRecipients?.map((recipient) => (
                                    <tr key={recipient?.id}>
                                        <td>{recipient?.email}</td>
                                        <td>{recipient?.sentAt ? moment.unix(recipient?.sentAt).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                                        <td>{RECIPIENTS_LETTER_STATUSES[recipient?.status]}</td>
                                        <td>{locale(`reminders.${recipient?.opened ? 'yes' : 'no'}`)}</td>
                                        <td width={40}>
                                            <Button
                                                disabled={recipient?.status != 'notSent'}
                                                onClick={() => onSendMail(recipient?.id)}
                                            >
                                                Отправить повторно
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <PaginationBar
                            pageCount={pageCount}
                            activePage={activePage}
                            onSelect={setActivePage}
                        />
                    </>
            }
        </>
    );
};

export default ReminderRecipientsTable;
